import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { logger } from '../utils/logger';
import { userService } from '../services/userService';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const redirectToProfile = async () => {
      try {
        setLoading(true);
        const profile = await userService.getProfile();

        if (profile.username) {
          // Redirect to user's public profile
          navigate(`/users/${profile.username}`, { replace: true });
        } else {
          setError('Username not found. Please complete your profile setup.');
        }
      } catch (err: any) {
        logger.error('Error loading profile:', err);
        setError('Failed to load profile. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    redirectToProfile();
  }, [navigate]);

  if (loading) {
    return (
      <div className="container" style={{ padding: '2rem', textAlign: 'center' }}>
        <div className="spinner"></div>
        <p style={{ marginTop: '1rem', color: 'var(--text-primary)' }}>Loading your profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container" style={{ padding: '2rem' }}>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <h2 style={{ fontFamily: 'var(--serif)', fontWeight: 400 }}>Error</h2>
          <p style={{ color: 'var(--text-primary)', marginBottom: '2rem' }}>{error}</p>
        </div>
      </div>
    );
  }

  // This should never render since we redirect
  return null;
};

export default Dashboard;
